const { regClass, property } = Laya;

import Toy, { TOY_STATE } from "./Toy";
import PhysicsGameMainRT from "./PhysicsGameMainRT";
import LoadingRT from "../LoadingRT";
import { Main } from "../Main";

import {DataCenter} from "./../DataCenter";

import ToyProto from "./ToyProto";
import * as consts from "./const";
import LevelLayer from "./LevelLayer";
import Stock from "./Stock";
import * as Anim from "./Anim";
import { LanguageService } from "./Lang";
import * as Env from "./../Env";

const VISUAL_LAYER : number = 4

@regClass('5iJgbfCiSn6Rc8upAfHtjA')
export default class GameLevel extends Laya.Script {

    static instance: GameLevel = null;
    constructor() {
        super();
        GameLevel.instance = this;
    }

    @property({ type: [Laya.Prefab] })
    toys: Laya.Prefab[];
    @property({ type: [Laya.Material] })
    mats: Laya.Material[];
    @property({ type: Laya.Prefab })
    block: Laya.Prefab;
    @property({ type: Laya.Texture })
    bg: Laya.Texture;
    @property({ type: Laya.Texture })
    stockTag: Laya.Texture;

    @property({ type: [Laya.Texture] })
    tools: Laya.Texture[];
    
    @property({ type: [Laya.Texture] })
    toySkins: Laya.Texture[];
    
    @property({ type: [Laya.Prefab] })
    xmastoys: Laya.Prefab[];

    @property({ type: [Laya.Texture] })
    xmasSkins: Laya.Texture[];

    private _time: number = 0;
    private _main: Laya.Sprite;
    private _expect_moving: number = 0;
    private _init_offset : number = 0;
    private _speed: number = 0;
    public _inReset: boolean = false;
    private _moveTimer: number = 0;

    public _started: boolean = false;
    private _gameBox: Laya.Sprite;
    public _dynamicBox: Laya.Sprite;
    private _levelclip: Laya.FontClip;
    private _arrow: Laya.Image;
    private _leftText:Laya.Text;
    private _scoreText:Laya.Label;
    private _t_scoreText:Laya.Label;
    private _comboText:Laya.FontClip;

    private _toyProtos: ToyProto[] = [];
    private _collect_proto: ToyProto = null;
    private _minToy: Laya.Sprite;
    private _maxToy: Laya.Sprite;
    private _hover: Laya.Sprite;
    private _unlock1: Laya.Image;
    private _unlock2: Laya.Image;
    private _ground_l: Laya.Sprite;
    private _ground_r: Laya.Sprite;
    private _drop_line: Laya.Sprite;
    private _start_tip: Laya.Label;
    private _lightning: Laya.Sprite;
    private _click: Laya.Sprite;
    //private _gamecity: Laya.Label;

    private _stock: Laya.Sprite;
    private _sideImg: Laya.Image;

    private _win: Laya.Sprite;
    private _win_content: Laya.Box;
    private _win_score: Laya.Label;
    private _win_label: Laya.Label;
    private _next_btn: Laya.Button;

    private _lose: Laya.Sprite;
    private _lose_content: Laya.Box;
    private _btn_retry: Laya.Button;
    private _btn_back: Laya.Button;
    private _img_person: Laya.Image;
    private _retry_tip: Laya.Label;

    private _setting: Laya.Sprite;
    private _btn_music: Laya.Button;
    private _btn_sound: Laya.Button;
    private _btn_viber: Laya.Button;

    private _tool: Laya.Sprite;
    private _tool_img: Laya.Image;
    private _tool_tips: Laya.Label;
    // private _pot: Laya.Sprite;
    // private _pot_2: Laya.Sprite;
    private _tool_title: Laya.Label;
    private _video: Laya.Sprite;
    private _tool_id: number;
    private _collect: Laya.Sprite;
    private _goal: Laya.Text;

    private _toolCall: () => void;
    private _toolClose: () => void;

    public _matchingToys: Laya.Sprite[] = [];
    public _bottomToyY: number = Laya.stage.height - consts.BOTTOM_TOY_HEIGHT;

    public _toyCapacity: number = 5;
    //public _curSize: number = consts.TOY_SIZE - 16;
    //public _level: Level = new Level();
    public _level:number = 0;
    //couple = row[1]
    public _level_type:number = 0;
    public _city_str:string = "";

    public _has_thunder: boolean = false;
    public _layers:LevelLayer[] = [];
    public _leftCount:number = 0;
    public _score:number = 0;
    public _combo:number = 0;

    public _gridData: {[key: string]: string} = {};
    public _moveCountDown: number = 0;
    public _genLayerIdx: number = 0;
    public _whole_move:number = 0;
    public _relax_toy:Laya.Sprite = null;
    public _relax_end_tick:number = 0;
    public _revive_count:number = 0;
    public _match_count:number = 0;
    public _reset_count:number = 0;
    public _guide_time:number = 1000;
    public _last_match_time:number = 0;
    public _tool_count:number = 0;
    public _collect_count:number = 0;

    onEnable(): void {
        if (this._toyProtos.length > 0) {
            this.genToys();
            return;
        }
        Laya.SoundManager.playMusic("resources/cdn/bgm.mp3");
        let img = new Laya.Image();
        img.alpha = 0;
        img.width = 90;
        img.height = 90;
        img.color = "000000";
        img.anchorX = 0;
        img.anchorY = 0;
        img.x = 0;
        img.y = 0;
        this._sideImg = img;

        let resArr: Array<string> = [
            "atlas/obj/icon_jewel_01.png"
        ];
        //加载2D
        Laya.loader.load(resArr).then((res) => {
            this._main = this.owner.getChildByName("Box") as Laya.Sprite;
            DataCenter.instance.adjustScreen(this._main);
            this._time = Date.now();
            this._gameBox = this._main.getChildByName("gameBox") as Laya.Sprite;
            this._dynamicBox = this._main.getChildByName("dynamicBox") as Laya.Sprite;
            this._hover = this._gameBox.getChildByName("hover") as Laya.Sprite;
            this._ground_l = this._main.getChildByName("block_l") as Laya.Sprite;
            this._ground_r = this._main.getChildByName("block_r") as Laya.Sprite;
            this._drop_line = this._main.getChildByName("drop_line") as Laya.Sprite;
            this._start_tip = this._main.getChildByName("start_tip") as Laya.Label;
            this._lightning = this._main.getChildByName("lightning") as Laya.Sprite;
            this._click = this._main.getChildByName("click") as Laya.Sprite;
            //this._gamecity = this._main.getChildByName("gamecity") as Laya.Label;

            this._setting = this._main.getChildByName("setting") as Laya.Sprite;
            this._btn_music = this._setting.getChildByName("btn_music") as Laya.Button;
            this._btn_sound = this._setting.getChildByName("btn_sound") as Laya.Button;
            this._btn_viber = this._setting.getChildByName("btn_viber") as Laya.Button;

            this._btn_music.selected = Laya.SoundManager.musicVolume < 0.1;
            this._btn_sound.selected = Laya.SoundManager.soundVolume < 0.1;

            this._btn_music.on(Laya.Event.CLICK, this, this.onClickMusic);
            this._btn_sound.on(Laya.Event.CLICK, this, this.onClickSound);
            this._btn_viber.on(Laya.Event.CLICK, this, this.onClickViber);

            this._win = this._main.getChildByName("win") as Laya.Sprite;
            this._win_content = this._win.getChildByName("content") as Laya.Box;
            this._next_btn = this._win_content.getChildByName("next") as Laya.Button;
            this._win_score = this._win_content.getChildByName("score") as Laya.Label;
            this._win_label = this._win_content.getChildByName("label") as Laya.Label;

            this._lose = this._main.getChildByName("lose") as Laya.Sprite;
            this._tool = this._main.getChildByName("tool") as Laya.Sprite;
            this._stock = this._main.getChildByName("stock") as Laya.Sprite;
            
            this._tool_img = this._tool.getChildByName("img") as Laya.Image;
            this._tool_tips = this._tool.getChildByName("tips") as Laya.Label;

            this._collect = this._main.getChildByName("collect") as Laya.Sprite;
            this._goal = this._main.getChildByName("goal") as Laya.Text;

            this._lightning.visible = false;
            this._click.visible = false;
            this._win.visible = false;
            this._lose.visible = false;
            this._setting.visible = false;
            this._tool.visible = false;
            this._collect.visible = false;
            this._goal.visible = false;

            let tool_btn = this._tool.getChildByName("btn") as Laya.Sprite;
            tool_btn.on(Laya.Event.CLICK, this, this.onClickTool);
            this._video = tool_btn.getChildAt(0) as Laya.Sprite;
            this._tool.getChildByName("close").on(Laya.Event.CLICK, this, this.onClickToolClose);
            this._tool_title = this._tool.getChildByName("label") as Laya.Label;

            this._next_btn.on(Laya.Event.CLICK, this, this.onClickNext);
            this._lose_content = this._lose.getChildByName("content") as Laya.Box;
            this._btn_retry = this._lose_content.getChildByName("retry") as Laya.Button;
            this._btn_retry.on(Laya.Event.CLICK, this, this.onClickRetry);
            this._btn_back = this._lose_content.getChildByName("main") as Laya.Button;
            this._btn_back.on(Laya.Event.CLICK, this, this.onClickMain);
            this._img_person = this._lose_content.getChildByName("person") as Laya.Image;
            this._retry_tip = this._lose_content.getChildByName("retryTip") as Laya.Label;

            this._main.getChildByName("set").on(Laya.Event.CLICK, this, this.onClickSet);

            this._setting.getChildByName("close").on(Laya.Event.CLICK, this, this.onClickSettingClose);
            this._setting.getChildByName("main").on(Laya.Event.CLICK, this, this.onClickSettingMain);

            this._main.getChildByName("reset").on(Laya.Event.CLICK, this, this.onClickReset);
            this._main.getChildByName("match").on(Laya.Event.CLICK, this, this.onClickMatch);
            this._unlock1 = this._main.getChildByName("unlock1") as Laya.Image;
            this._unlock2 = this._main.getChildByName("unlock2") as Laya.Image;
            this._unlock1.on(Laya.Event.CLICK, this, this.onClickUnlock1);
            //this._unlock2.on(Laya.Event.CLICK, this, this.onClickUnlock2);

            this._levelclip = this._main.getChildByName("level") as Laya.FontClip;
            this._arrow = this._main.getChildByName("arrow") as Laya.Image;
            this._leftText = this._main.getChildByName("leftCount") as Laya.Text;
            this._scoreText = this._main.getChildByName("score") as Laya.Label;
            this._t_scoreText = this._main.getChildByName("t_score") as Laya.Label;
            this._comboText = this._main.getChildByName("combo") as Laya.FontClip;
            this._scoreText.text = "0";
            this._comboText.visible = false;

            this._score = 0;
            this._combo = 1;
            this.initTexts();

            if(consts.MODE_XMAS == DataCenter.instance.level_mode)
                this.InitXmasGameUI(this._main);

            this.generateToyProtos();
        });
    }

    InitXmasGameUI(main: Laya.Node) {
        let names = ["block_down", "bg", "ground_left", "ground_right"];
        for(let i = 0; i < names.length; i++) {
            let name = names[i];
            let img = main.getChildByName(name) as Laya.Image;
            img.skin = this.xmasSkins[i].url;
        }
    }
    initTexts() {
        (this._main.getChildByName("reset") as Laya.Button).label = LanguageService.instance.translate("shuffle");
        (this._main.getChildByName("match") as Laya.Button).label = LanguageService.instance.translate("remove");
        (this._main.getChildByName("sy") as Laya.Label).text = LanguageService.instance.translate("remain");
        (this._main.getChildByName("df") as Laya.Label).text = LanguageService.instance.translate("score");
        this._next_btn.label = LanguageService.instance.translate("nextlevel");
        this._btn_retry.label = LanguageService.instance.translate("restart");
        (this._tool.getChildByName("btn") as Laya.Button).label = LanguageService.instance.translate("use");

    }

    showGuide() {
        if(this._maxToy)
        {
            this._click.visible = true;
            this._click.x = this._maxToy.x;
            this._click.y = this._maxToy.y;
        }
    }

    freeToolCount(){
        return this._tool_count < 3 || this._tool_count >= 6;
    }

    showTool(img_id:number, title:string, tips:string, call: () => void, close?: () => void) {
        this._tool_id = img_id;
        this._tool.visible = true;
        this._started = false;
        Env.gameStop();
        this._toolCall = call;
        this._toolClose = close;
        this._tool_img.skin = this.tools[img_id].url;
        this._tool_tips.text = tips;
        this._tool_title.text = title;
        this._video.visible = true
        if(this._tool_id < 2) {
            this._video.visible = !this.freeToolCount();
        }
        consts.playSound("resources/cdn/open.mp3");
    }
    onClickTool() {
        let type = "rewarded";
        if(this._tool_id < 2) {
            if(this.freeToolCount()) {
                type = "";
            }
            this._tool_count ++;
        }
        Env.ShowAd(type, () => {
            if(this._toolCall) {
                this._toolCall();
                this._tool.visible = false;
                this._started = true;
                Env.gameStart();
            }
        }, () =>{

        });
    }
    onClickToolClose() {
        if(this._toolClose) {
            this._toolClose();
        }
        this._tool.visible = false;
        this._started = true;
        if(this._tool_id != 2) {
            Env.gameStart();
        }
        //Laya.SoundManager.playSound("resources/cdn/close.mp3");
    }

    startRelax() {
        let count = this._gameBox.numChildren;
        for(let i = 1; i < count; i++) {
            let toy = this._gameBox.getChildAt(i) as Laya.Sprite;
            let toyScript = toy.getComponent(Toy);
            let st = toyScript.state;
            if(st == TOY_STATE.STATIC || st == TOY_STATE.LOCKED) {
                let rig = toy.getComponent(Laya.RigidBody);
                rig.setVelocity({ x: 0, y: 0 });
                rig.angularVelocity = 0;
                if(toy.visible) {
                    rig.type = "dynamic";
                    rig.gravityScale = 0;
                }
                else {
                    rig.type = "static";
                    rig.gravityScale = consts.gravity;
                }
            }
        }
        this._relax_end_tick = consts.RELAX_DUR;
        if(this._level_type == consts.LEVEL_TYPE_LEFT) {
            this.enableBlock(this._ground_l, false);
        }
        else if(this._level_type == consts.LEVEL_TYPE_RIGHT) {
            this.enableBlock(this._ground_r, false);
        }
    }

    doShuffle() {

            this._inReset = true;
            let count = this._gameBox.numChildren;
            let currentIndex = count - 1;
            
            while (currentIndex > 0) {
                const randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;

                const curr_toy = this._gameBox.getChildAt(currentIndex + 1) as Laya.Sprite;
                const rand_toy = this._gameBox.getChildAt(randomIndex + 1) as Laya.Sprite;
                
                let st = curr_toy.getComponent(Toy).state;
                if(st == TOY_STATE.MATCHING || st == TOY_STATE.MATCHED) {
                    continue;
                }            
                st = rand_toy.getComponent(Toy).state;
                if(st == TOY_STATE.MATCHING || st == TOY_STATE.MATCHED) {
                    continue;
                }

                this.swapToy(curr_toy, rand_toy);
            }

            for(let i = 1; i < count; i++) {
                let toy = this._gameBox.getChildAt(i) as Laya.Sprite;
                let toyScript = toy.getComponent(Toy);
                let st = toyScript.state;
                if(st == TOY_STATE.DROP) {
                    st = TOY_STATE.STATIC;
                    toyScript.state = st;
                }
            }
            this.startRelax();

            //this.doMoveToy(0, true, false);
            this._inReset = false;
            this.checkLock();
    }

    onClickReset() {
        if(!this._started) {
            return;
        }

        this.showTool(0, LanguageService.instance.translate("shuffle"), LanguageService.instance.translate("shuffletip"), () => 
        {
            this._reset_count++;
            if(this._reset_count >= consts.MAX_RESET_COUNT) {            
                let btn = this._main.getChildByName("reset") as Laya.Button;
                btn.disabled = true;
            }
            this.doShuffle();
        }
        );
    }

    doRevive(){
        let leftCount = this._toyCapacity - 2;
        while(this._matchingToys.length > leftCount){
            let toy = this._matchingToys.pop();
            let toy_i = toy.getComponent(Toy);
            toy_i.state = TOY_STATE.DROP;
        }
        let no_space : Laya.Sprite[] = [];
        let count = this._gameBox.numChildren;
        for(let i = 1; i < count; i++) {
            let toy = this._gameBox.getChildAt(i) as Laya.Sprite;
            let toyScript = toy.getComponent(Toy);
            let st = toyScript.state;
            if(st == TOY_STATE.DROP) {
                st = TOY_STATE.STATIC;
                toyScript.state = st;
                let x = toyScript._oX;
                let y = toyScript._oY;
                if (this._level_type == consts.LEVEL_TYPE_BOTTOM){
                    y += this._whole_move;
                    if(y >= this._bottomToyY + 20) {
                        no_space.push(toy);
                        continue;
                    }
                }                    
                else if(this._level_type == consts.LEVEL_TYPE_LEFT){
                    x += this._whole_move;
                    if(x > this._maxToy.x) {
                        no_space.push(toy);
                        continue;
                    }
                }                    
                else if(this._level_type == consts.LEVEL_TYPE_RIGHT){
                    x -= this._whole_move;
                    if(x < this._maxToy.x) {
                        no_space.push(toy);
                        continue;
                    }
                }
                toy.pos(x, y);
            }
        }
        if(no_space.length > 0) {
            let top_extra = 100
            this.findSpace(no_space, consts.VIEW_WIDTH, consts.getViewHeight(),
             consts.SIDE_OFFSET, consts.TOP_OFFSET - top_extra, 60);
            if(no_space.length > 0) {
                for(let i = 0; i < no_space.length; i++) {
                    let toy = no_space[i];
                    toy.pos(Math.random() * consts.VIEW_WIDTH + consts.SIDE_OFFSET, 
                    Math.random() * (consts.getViewHeight() + top_extra) + consts.TOP_OFFSET - top_extra);
                }
            }
        }
        this.startRelax();
    }

    inStock(toy: Laya.Sprite):[number, number, number] {
        let toyScript = toy.getComponent(Toy);
        let stocks = this.getStocks();

        for(let i = 0; i < stocks.length; i++) {
            let stock = stocks[i];
            let index = stock.toys.indexOf(toyScript);
            if(index >= 0) {
                return [i, index, -1];
            }
            index = stock.in_range_toys.indexOf(toyScript);
            if(index >= 0) {
                return [i, -1, index];
            }
        }
        return null;
    }

    setStockInfo(toy: Laya.Sprite, si: [number, number, number]) {
        if(si == null) {
            this.toyOutFromStock(toy);
            return;
        }
        let toyScript = toy.getComponent(Toy);
        let stocks = this.getStocks();
        let stock = stocks[si[0]];
        if(si[1] >= 0) {            
            this.toyIntoStock(toy);
            stock.toys[si[1]] = toyScript;
        }
        else {
            this.toyOutFromStock(toy);
            stock.in_range_toys[si[2]] = toyScript;
        }
    }

    swapToy(toy1: Laya.Sprite, toy2: Laya.Sprite) {

        let s1 = this.inStock(toy1);
        let s2 = this.inStock(toy2);

        let x = toy1.x;
        let y = toy1.y;
        toy1.x = toy2.x;
        toy1.y = toy2.y;
        toy2.x = x;
        toy2.y = y;
        
        if(s1 == null && s2 == null) {
            return;
        }
        this.setStockInfo(toy1, s2);
        this.setStockInfo(toy2, s1);
    }

    doMatch() {
       {
            this._match_count++;
            if(this._match_count >= consts.MAX_MATCH_COUNT) {
                let btn = this._main.getChildByName("match") as Laya.Button;
                btn.disabled = true;
            }
            this._matchingToys.sort((a, b) => {
                return a.y - b.y;
            })
            
            let matchingCount = this._matchingToys.length;
            for (let i = 0; i < matchingCount - 1; i++) {
                let toy_i = this._matchingToys[i].getComponent(Toy);
                for (let j = i + 1; j < matchingCount; j++) {

                    let toy_j = this._matchingToys[j].getComponent(Toy);
                    if(toy_i.canMatch(toy_j)) {
                        this.matched(this._matchingToys[i], this._matchingToys[j]);
                        return;
                    }
                }
            }
            let toy_top = this._maxToy;
            if(matchingCount > 0) {
                toy_top = this._matchingToys[0];
            }
            if(toy_top == null)
                return;
            let top_script = toy_top.getComponent(Toy);
            for (let i = 1; i < this._gameBox.numChildren; i++) {
                const toy = this._gameBox.getChildAt(i) as Laya.Sprite;
                if(toy == toy_top) {
                    continue;
                }

                let toy_script = toy.getComponent(Toy);
                if(toy_script.canforceMatch(top_script)) {
                    toy_script.setToyLocked(false);
                    top_script.setToyLocked(false);
                    this.toyDown(toy_top);
                    this.toyDown(toy);
                    this.matched(toy, toy_top);
                    this.getSideToys();
                    return;
                }
            }
        }
    }
    onClickMatch() {
        if(!this._started) {
            return;
        }
        this.showTool(1, LanguageService.instance.translate("remove"), LanguageService.instance.translate("removetip"), () => 
            this.doMatch()
        );
    }

    onClickUnlock1() {
        if(!this._started) {
            return;
        }
        this._started = false;
        Env.gameStop();
        Env.ShowAd("rewarded", () => {
            this._started = true;
            Env.gameStart();
            this._toyCapacity ++;
            if(this._toyCapacity == 4) {
                
                this._unlock2.visible = false;
                this._unlock1.x = this._unlock2.x;
                this._unlock1.y = this._unlock2.y;
                return;
            }
            this._unlock1.visible = false;
            this.enableBlock(this._unlock1, false);
            //this._unlock2.skin = this._unlock1.skin;
        }, () =>{
            this._started = true;
            Env.gameStart();
        });
    }
    // onClickUnlock2() {
    //     if(this._unlock1.visible) {
    //         return;
    //     }
    //     this._unlock2.visible = false;
    //     this.enableBlock(this._unlock2, false);
    //     this._toyCapacity ++;
    // }

    onStart(): void {
    }

    doOffset(offset : number) {
        this._whole_move += offset;
        let count = this._gameBox.numChildren;
        if(this._level_type == consts.LEVEL_TYPE_BOTTOM) {
            for(let i = 1; i < count; i++) {
                let toy = this._gameBox.getChildAt(i) as Laya.Sprite;
                let st = toy.getComponent(Toy).state;
                if(st == TOY_STATE.STATIC){

                    toy.y += offset;
                }
            }
        }
        else {
            if(this._level_type == consts.LEVEL_TYPE_RIGHT)
                offset = -offset;

            for(let i = 1; i < count; i++) {
                let toy = this._gameBox.getChildAt(i) as Laya.Sprite;
                let st = toy.getComponent(Toy).state;
                if(st == TOY_STATE.STATIC || st == TOY_STATE.LOCKED){
                    toy.x += offset;
                }
            }
        }
    }

    onUpdate(): void {

        if(this._moveCountDown > 0){
            this._moveCountDown -= Laya.timer.delta;
            if(this._moveCountDown <= 0) {
                this._moveCountDown = 0;
                this.moveToys(false);
            }
        }

        if(this._expect_moving > 0) {
            let offset = Laya.timer.delta * this._speed;            
            if(this._expect_moving < offset) {
                offset = this._expect_moving;
                this._expect_moving = 0;
            }
            else
                this._expect_moving -= offset;

            this.doOffset(offset);

            if(this._expect_moving == 0)
            {
                for (let i = 1; i < this._gameBox.numChildren; i++) {
                    const toy = this._gameBox.getChildAt(i) as Laya.Sprite;
                    let rig = toy.getComponent(Laya.RigidBody);
                    let st = toy.getComponent(Toy).state;
                    if(st == TOY_STATE.STATIC || st == TOY_STATE.LOCKED) {

                        rig.type = "static";
                    }
                }
                this.checkGenLayer(0);
                this.checkLock();
            }
        }
        else {
            if(this._moveTimer > 0) {
                this._moveTimer -= Laya.timer.delta;
            }
        }

        if(this._relax_end_tick > 0) {
            if(this._expect_moving <= 0)
            {
                this._relax_end_tick -= 1;
                if(this._relax_end_tick <= 0) {
                    let count = this._gameBox.numChildren;
                    for (let i = count - 1; i >= 1; i--) {
                        const toy = this._gameBox.getChildAt(i) as Laya.Sprite;
                        let toyScript = toy.getComponent(Toy);
                        if(toyScript.state == TOY_STATE.STATIC || toyScript.state == TOY_STATE.LOCKED) 
                        {                        
                            let rig = toy.getComponent(Laya.RigidBody);
                            rig.type = "static";
                            rig.gravityScale = consts.gravity;
                        }
                        if(toy == this._relax_toy) {
                            break;
                        }
                    }
                    this.enableBlock(this._ground_l, true);
                    this.enableBlock(this._ground_r, true);
                    this._relax_toy = null;
                    this.moveToys(false);
                    if(this._expect_moving > 0) {
                        this.startMove();
                    }
                }
            }
            return;
        }

        if(!this._started) {
            return;
        }

        let cur_score = parseInt(this._scoreText.text);
        if(cur_score != this._score) {
            let delta_score = Math.floor(Laya.timer.delta);
            if(delta_score < 1) {
                delta_score = 1;
            }
            cur_score += delta_score;
            if(cur_score > this._score) {
                cur_score = this._score;
            }
            this._scoreText.text = cur_score.toString();
        }

        if(this._level == 1 && this._guide_time > 0) {
            this._guide_time -= Laya.timer.delta;
            if(this._guide_time <= 0) {
                this._guide_time = 0;
                this.showGuide();
            }
        }

        let stocks = this.getStocks();
        if(stocks)
        {
            for(let i = 0; i < stocks.length; i++) {
                let stock = stocks[i];

                if(stock.in_range_toys.length == 0) {
                    if(stock.count_down > 0)
                        stock.count_down --;

                    if(stock.count_down <= 0) {                    
                        stock.count_down = consts.STOCK_COUNT_DOWN;
                        this.popStock(stock);
                    }
                }
            }
        }

        let matchingCount = this._matchingToys.length;
        if (matchingCount < 2) {
            return;
        }

        for (let i = 0; i < matchingCount; i++) {
            let toy = this._matchingToys[i].getComponent(Toy);
            if (toy._delta > 2) {
                return;
            }
        }
        this._matchingToys = this._matchingToys.sort((a, b) => {
            return b.y - a.y;
        })

        for (let i = 1; i < matchingCount; i++) {
            let toy1 = this._matchingToys[i];
            let toy2 = this._matchingToys[i - 1];
            if(toy1.x < consts.MATCH_LEFT || toy1.x > consts.MATCH_RIGHT) {
                return;
            }
            if(toy2.x < consts.MATCH_LEFT || toy2.x > consts.MATCH_RIGHT) {
                return;
            }
            if (toy1.getComponent(Toy).canMatch(toy2.getComponent(Toy))) {
                if (Math.abs(toy1.y - toy2.y) <= consts.TOY_SIZE) {
                    this.matched(toy1, toy2);
                }
                return;
            }

            if(DataCenter.instance.block_tips && this._level <= 3 && i >= 1 && DataCenter.instance.level_mode == consts.MODE_COMMON) {
                DataCenter.instance.block_tips = false;
                this._start_tip.visible = true;
                this._start_tip.texture = this.bg;
                this._start_tip.alpha = 1;
                this._started = false
                this._start_tip.text = LanguageService.instance.translate("guide_block").replace("XXX", this._toyCapacity.toString());
                Laya.Tween.to(this._start_tip, { alpha: 0 }, 500, null, Laya.Handler.create(this, () => {
                    this._start_tip.visible = false;
                    this._started = true
                }), 5000);   
            }
            
            if (i >= this._toyCapacity) {
                this.Losing();
                return;
            }  
        }      
    }

    endGame() {
        this._started = false;
        this._matchingToys = [];
        this._gameBox.removeChildren();
        this._gameBox.addChild(this._hover);
        //this._dynamicBox.removeChildren();
    }

    onShapeLoaded(text: string):void {
        console.log(text);
    }
    genCommonProtos(toys: Laya.Prefab[], styles: any[]): void {

            let seq = [1,2,3,4,5,6,7,8]
            let weights = [3, 7, 2, 4, 4, 3, 3, 3, 3];
            let proto
            for (let i = 0; i < weights.length; i++) {
                let weight = weights[i];
                let toy = toys[i + 1];
                seq = consts.shuffle(seq);
                for(let j = 0; j < weight; j++) {
                    let style = styles[seq[j]];
                    proto = new ToyProto(i, toy, style);
                    this._toyProtos.push(proto);
                }
            }
    }
    genXmasProtos(style: any): void {

            for(let i = 0; i < this.xmastoys.length; i++) {
                let prefab = this.xmastoys[i];
                let proto = new ToyProto(i, prefab, style);
                this._toyProtos.push(proto);
            }
    }
    generateToyProtos(): void {

        //Laya.loader.load("resources/game/toy_shapes.json").then((json) => {            
        Laya.loader.load("resources/game/grid.json").then((grid_json) => {
            this._gridData = grid_json.data;     
            this._toyProtos = [];
            let styles = DataCenter.instance.toy_style;
            let toys = this.toys;
             let mode = DataCenter.instance.level_mode;
            if(mode == consts.MODE_XMAS) {
                this.genXmasProtos(styles[0]);
            }
            else{
                this.genCommonProtos(toys, styles);
            }
            this._toyProtos = consts.shuffle(this._toyProtos);
            let proto = this._toyProtos[0];
            this._collect_proto = proto;
            proto.hasEdge = true;
            this._toyProtos[0] = new ToyProto(-1, toys[0], styles[0]);
            //this._toyProtos.push(proto);            
            
            this.genToys();
        });
        //});
    }

    init_data(data:any[]) {
        this._level = DataCenter.instance.level_id;
        this._level_type = data[2];
        this._city_str = data[3];
        let layers = data[5];
        let count = layers.length - 1;
        let collect_array : number[] = [];
        
        for(let i = 0; i < count - 1; i++) 
            collect_array.push(0);
        let is_collect = 0
        if(DataCenter.instance.level_mode == consts.MODE_COLLECT) {
            is_collect = 1;
        }        
        for(let i = 0; i < count - 1; i++) 
            collect_array.push(is_collect);
        consts.shuffle(collect_array);

        let clip_x = null
        for (let i = 0; i < count; i++) {
            let layer = new LevelLayer();
            if(i > 0) {
                layer._collect_count = collect_array[i * 2 - 2] + collect_array[i * 2 - 1];
            }
            layer.init_data(layers[i]);
            if(i == 0)
                clip_x = layer._clip_x;
            else
                layer._clip_x = clip_x;
            if(layer.block_id != 0) {
                let blockData = DataCenter.instance.getBlockData(layer.block_id);
                for(let j = 0; j < blockData.length; j += 2) {
                    this.addBlock(blockData[j], blockData[j + 1]);
                }
            }
            this._layers.push(layer);
        }
        this._levelclip.value = this._level.toString();
        //this._gamecity.text = this._city_str;
    }
    
    fixPoints(layer:LevelLayer, grid:number):void{
        let offset = 88
        let str = this._gridData[grid];
        let len = str.length;
        let y = 0;
        for (let i = 0; i < len; i += 2) {
            let x = -70;
            if(i % 4 == 2) {
                x += offset * 0.5;
            }

            for(let j = 0; j < 2; j ++){
                let v = parseInt(str[i + j],16);
                for(let k = 3; k >=0 ; k --){

                    x += offset;
                    if((v & (1 << k)) != 0){
                        layer.add_point([x, y]);
                    }
                }
            }
            y -= offset * 0.75;
        }
    }
    genToyLayer():void{
        let SideOffset = consts.HALF_TOY_IMAGE;
        let TopOffset = -200;

        let proto_idx = 0;
        let other_layer_idx = 0;
        let is_sep = false;

        let p1:any = null;
        let p2:any = null;
        let spec1 = 0;
        let spec2 = 0;

        let i = this._genLayerIdx;
        if(i >= this._layers.length) {
            return;
        }
        this._relax_end_tick = consts.RELAX_DUR;
        let count = this._gameBox.numChildren;
        this._genLayerIdx ++;
        //for (let i = 0; i < this._layers.length; i++) 
        {
            let layer = this._layers[i];
            let layer_h = i * consts.LAYER_HEIGHT;
            
            let cur_p = 0
            let proto_count = layer.proto_count();

            let fix_index = -1;
            while(layer.has_point()) {
                fix_index ++;
                if(layer.has_fix_veg(fix_index)){
                    proto_idx = layer.fix_proto_idx(fix_index);
                    other_layer_idx = i + layer.fix_layer_offset(fix_index);
                    is_sep = layer.fix_sep(fix_index);
                }
                else{
                    if(layer.get_collect()){
                        proto_idx = -1;
                    }
                    else{
                        if(cur_p < proto_count) {
                            cur_p ++;
                            proto_idx = cur_p;
                        }
                        else
                            proto_idx = layer.rand_proto_idx();
                        
                    }
                    other_layer_idx = i + layer.rand_layer_offset();
                    is_sep = layer.rand_seperated();
                }

                if(other_layer_idx >= this._layers.length) {
                    other_layer_idx = i;
                }
                let other_layer = this._layers[other_layer_idx];
                if (other_layer_idx == i){
                    if(is_sep){
                        p1 = layer.pop_left();
                        spec1 = layer.pop_spec_toy(p1);
                        p2 = layer.pop_right();
                    }
                    else{
                        p1 = layer.pop_left();
                        spec1 = layer.pop_spec_toy(p1);
                        p2 = layer.pop_left();
                    }

                    if(p2 == null) {
                        other_layer_idx = i + 1;
                        if(other_layer_idx < this._layers.length) {
                            other_layer = this._layers[other_layer_idx];
                            p2 = other_layer.pop_point();
                            spec2 = other_layer.pop_spec_toy(p2);
                        }
                    }
                    else
                        spec2 = layer.pop_spec_toy(p2);
                }
                else{
                    p1 = layer.pop_point();
                    spec1 = layer.pop_spec_toy(p1);
                    p2 = other_layer.pop_point();
                    spec2 = other_layer.pop_spec_toy(p2);
                }
                if(p2 == null) {
                    continue;
                }
                let other_layer_h = other_layer_idx * consts.LAYER_HEIGHT;
                let proto = this._collect_proto
                if(proto_idx >= 0) {
                    proto = this._toyProtos[proto_idx + 1];
                }
                else{
                    this._collect_count += 2;
                }
                if (this._level_type == consts.LEVEL_TYPE_BOTTOM) {
                    this.createToy(p1[0] + SideOffset,p1[1] - layer_h, 0, this._whole_move, proto, spec1);
                    this.createToy(p2[0] + SideOffset,p2[1] - other_layer_h,0, this._whole_move, proto, spec2);
                }
                else if(this._level_type == consts.LEVEL_TYPE_LEFT){
                    this.createToy(p1[1] - layer_h,p1[0] + TopOffset, this._whole_move, 0, proto, spec1);
                    this.createToy(p2[1] - other_layer_h,p2[0] + TopOffset, this._whole_move, 0, proto, spec2);
                }
                else if(this._level_type == consts.LEVEL_TYPE_RIGHT){
                    this.createToy(p1[1] + layer_h,p1[0] + TopOffset,  -this._whole_move, 0, proto, spec1);
                    this.createToy(p2[1] + other_layer_h,p2[0] + TopOffset, -this._whole_move, 0, proto, spec2);
                }

                //this._leftCount += 2;
            }
        }
        if(this._relax_toy == null) {
            this._relax_toy = this._gameBox.getChildAt(count) as Laya.Sprite;
        }
    }

    genToys(): void {            
        this._tool_count = 0
        this.init_data(DataCenter.instance.level_data);
        this._win.visible = false;
        this._lose.visible = false;
        this._setting.visible = false;
        this._drop_line.visible = false;

        this._toyCapacity = 3;
        this._unlock1.visible = true;
        this.enableBlock(this._unlock1, true);
        this._unlock2.visible = true;
        //this.enableBlock(this._unlock2, true);
        this._leftCount = 0;
        this._collect_count = 0;
        let drop_offset = consts.SIDE_DROP_OFFSET - 45;

        this._speed = consts.MOVE_SPEED_VERTICAL;
        if(this._level_type == consts.LEVEL_TYPE_LEFT) {
            this.enableBlock(this._ground_l, false);
            this._drop_line.x = 720 - drop_offset;
            this._drop_line.visible = true;
            this._speed = consts.MOVE_SPEED_HORIZONTAL;
        }
        else if(this._level_type == consts.LEVEL_TYPE_RIGHT) {
            this.enableBlock(this._ground_r, false);
            this._drop_line.visible = true;
            this._drop_line.x = drop_offset;
            this._speed = consts.MOVE_SPEED_HORIZONTAL;
        }

        let gen_w = consts.GEN_WIDTH;
        if(this._level_type != consts.LEVEL_TYPE_BOTTOM) {
            gen_w = consts.GEN_HEIGHT;
        }
        let has_stock = this.hasStock();
        for (let i = 0; i < this._layers.length; i++) {
            let layer = this._layers[i];
            layer.init_points();
            if(layer._map_veg.length == 0) {
                continue;
            }
            if(has_stock){
                //layer._clip_y =  1280 - Laya.stage.height + consts.LAYER_HEIGHT * i - 90;
            }
            layer.gen_width = gen_w;            
            if(layer.fix_point_id != 0) {
                this.fixPoints(layer, layer.fix_point_id);
            }
            else{
                this.poissonDiskSampling(layer, gen_w, consts.LAYER_HEIGHT, layer.min_size, 60);
            }
            layer.remove_points(layer.remove_veg);
            this._leftCount += layer.all_points_ready();
        }
        if(has_stock)
        {
            let stocks = this.getStocks();
            for(let i = 0; i < stocks.length; i++) {
                let stock = stocks[i];
                this._leftCount += stock.expect_num;
            }
        }
        
        if(this._leftCount % 2 == 1) {
            this._leftCount --;
        }
        for(let i = 0; i < this._layers.length; i++) {
            this.genToyLayer();
        }

        this.moveToys(true);
        this._init_offset = this._whole_move;

        this.checkGenLayer(0);
        this._leftText.text = "" + this._leftCount;
        let stocks = this.getStocks();
        for(let i = 0; i < stocks.length; i++) {
            let stock = stocks[i];
            this.popStock(stock);
        }

        if(DataCenter.instance.level_mode == consts.MODE_COLLECT) {
            this._collect.visible = true;
            this._collect.alpha = 1;
            this._goal.visible = true;
            this._goal.x = 114;
            this._goal.y = 545;
            let collect_text = this._collect.getChildAt(0) as Laya.Label;
            collect_text.text = LanguageService.instance.translate("goal");
            this._goal.text = "x " + this._collect_count;
            Toy.setToyImage(this._goal.getChildAt(1) as Laya.Image, this._collect_proto);
            Laya.timer.once(1500, this, () => {
                this.showStartAnim();
                Anim.Alpha0_2(this._collect, 0, 500)
                let ty = this._main.height - 170;
                Laya.Tween.to(this._goal, { x: 325, y: ty }, 500)
            });
        }
        else
            this.showStartAnim();
    }
    initArrow() {
        let arrow = this._arrow;
        Laya.Tween.clearTween(arrow);
        let cx = this._main.width * 0.5;
        let cy = this._main.height * 0.5 - 100;
        arrow.x = cx;
        arrow.y = cy;
    }

    showStartAnim() {
        let start_dur = 1000;
        this._start_tip.visible = false;
        this._arrow.visible = false;
        if(this._has_thunder) {
            this._lightning.visible = true;
            consts.playSound("resources/cdn/lightning.mp3");
        }
        if(this._level_type != consts.LEVEL_TYPE_BOTTOM) {
            let arrow = this._arrow;
            arrow.scaleX = 1;
            this._start_tip.text = LanguageService.instance.translate("moveright");
            if(this._level_type == consts.LEVEL_TYPE_RIGHT){
                this._start_tip.text = LanguageService.instance.translate("moveleft");
                arrow.scaleX = -1;
            }
            this._start_tip.visible = true;
            this._start_tip.texture = this.bg;
            arrow.visible = true;

            let arrow_x = 274;
            let arrow_y = 100;
            let dur = 2650;
            let dur2 = 500;
            this.initArrow();

            start_dur = dur + dur2
            this._start_tip.alpha = 1;
            Laya.timer.once(500, this, () => {
                Anim.Rotate(arrow, 3, 5, 150, () => {
                    Laya.Tween.to(arrow, { x: arrow_x, y: arrow_y }, dur2, null, Laya.Handler.create(null, () => {
                            Anim.Alpha0_2(this._start_tip, 0, 500);
                    }));
                });
            });
            
        }

        Laya.timer.once(start_dur, this, () => {
            this.startGame();
        });

    }


    enableBlock(sprite: Laya.Sprite, enable: boolean) {
        let box =  sprite.getComponent(Laya.BoxCollider);
        box.isSensor = !enable;
        // let rig = sprite.getComponent(Laya.RigidBody);
        // rig.enabled = true;
        // rig.type = "static";
    }
    checkGenLayer(offset: number)
    {
        let delta = (this._whole_move - this._init_offset) - (this._genLayerIdx - VISUAL_LAYER) * consts.LAYER_HEIGHT;
        //console.log("aaa:" + delta );
        //this._title.text = "" + delta;
        if(delta > offset)
            this.genToyLayer();
    }

    poissonDiskSampling(
        layer:LevelLayer,
        width: number,
        height: number,
        minDist: number,
        samples: number = 30
    ) {
        const grid: ([number, number] | undefined)[] = [];
        const active: [number, number][] = [];
        
        const cellSize: number = minDist / Math.sqrt(2);
        const cols: number = Math.ceil(width / cellSize);
        const rows: number = Math.ceil(height / cellSize);

        if(layer._stocks.length > 0) {
            for(let k = 0; k < layer._stocks.length; k++) {
                let st = layer._stocks[k];
                let st_pos : [number, number] = consts.STOCK_POS[st.stock_index];
                active.push(st_pos);                
                const i: number = Math.floor(st_pos[0] / cellSize);
                const j: number = Math.floor(st_pos[1] / cellSize);
                grid[j * cols + i] = st_pos;
            }
        }
        else{
            const x0: number = Math.random() * width;
            const y0: number = Math.random() * height;
            const pos0: [number, number] = [x0, y0];
            layer.add_point(pos0);
            active.push(pos0);
            
            const i: number = Math.floor(x0 / cellSize);
            const j: number = Math.floor(y0 / cellSize);
            grid[j * cols + i] = pos0;
        }        
        
        while (active.length > 0) {
            const randomIndex: number = Math.floor(Math.random() * active.length);
            const point: [number, number] = active[randomIndex];
            let found: boolean = false;
            
            for (let k = 0; k < samples; k++) {
                const angle: number = Math.random() * Math.PI * 2;
                const radius: number = minDist + Math.random() * minDist;
                const newX: number = point[0] + Math.cos(angle) * radius;
                const newY: number = point[1] + Math.sin(angle) * radius;
                
                if (newX < 0 || newX >= width || newY < 0 || newY >= height) continue;
                
                const col: number = Math.floor(newX / cellSize);
                const row: number = Math.floor(newY / cellSize);
                
                if (col < 0 || col >= cols || row < 0 || row >= rows) continue;
                
                let valid: boolean = true;
                for (let i = -1; i <= 1; i++) {
                    for (let j = -1; j <= 1; j++) {
                        const neighborCol: number = col + i;
                        const neighborRow: number = row + j;
                        if (neighborCol >= 0 && neighborCol < cols && neighborRow >= 0 && neighborRow < rows) {
                            const neighbor = grid[neighborRow * cols + neighborCol];
                            if (neighbor) {
                                const dx: number = neighbor[0] - newX;
                                const dy: number = neighbor[1] - newY;
                                if (dx * dx + dy * dy < minDist * minDist) {
                                    valid = false;
                                    break;
                                }
                            }
                        }
                    }
                    if (!valid) break;
                }
                
                if (valid) {
                    const newPoint: [number, number] = [newX, newY];
                    layer.add_point(newPoint);
                    active.push(newPoint);
                    grid[row * cols + col] = newPoint;
                    found = true;
                    break;
                }
            }
            
            if (!found) {
                active.splice(randomIndex, 1);
            }
        }
    }

    findSpace(
        sprites:Laya.Sprite[],
        width: number,
        height: number,
        sideOffset: number,
        topOffset: number,
        minDist: number,
        samples: number = 30
    )
    {
        const grid: ([number, number] | undefined)[] = [];
        const active: [number, number][] = [];
        
        const cellSize: number = minDist / Math.sqrt(2);
        const cols: number = Math.ceil(width / cellSize);
        const rows: number = Math.ceil(height / cellSize);

        for (let i = 1; i < this._gameBox.numChildren; i++) {
            let toy = this._gameBox.getChildAt(i) as Laya.Sprite;
            let toyScript = toy.getComponent(Toy);
            let st = toyScript.state;
            if(st == TOY_STATE.STATIC) {
                let st_pos : [number, number] = [toy.x - sideOffset, toy.y - topOffset];
                const i: number = Math.floor(st_pos[0] / cellSize);
                const j: number = Math.floor(st_pos[1] / cellSize);
                if(i < 0 || i >= cols || j < 0 || j >= rows) {
                    continue;
                }
                active.push(st_pos);                
                grid[j * cols + i] = st_pos;
            }
        }
        
        while (active.length > 0) {
            const randomIndex: number = Math.floor(Math.random() * active.length);
            const point: [number, number] = active[randomIndex];
            let found: boolean = false;
            
            for (let k = 0; k < samples; k++) {
                const angle: number = Math.random() * Math.PI * 2;
                const radius: number = minDist + Math.random() * minDist;
                const newX: number = point[0] + Math.cos(angle) * radius;
                const newY: number = point[1] + Math.sin(angle) * radius;
                
                if (newX < 0 || newX >= width || newY < 0 || newY >= height) continue;
                
                const col: number = Math.floor(newX / cellSize);
                const row: number = Math.floor(newY / cellSize);
                
                if (col < 0 || col >= cols || row < 0 || row >= rows) continue;
                
                let valid: boolean = true;
                for (let i = -1; i <= 1; i++) {
                    for (let j = -1; j <= 1; j++) {
                        const neighborCol: number = col + i;
                        const neighborRow: number = row + j;
                        if (neighborCol >= 0 && neighborCol < cols && neighborRow >= 0 && neighborRow < rows) {
                            const neighbor = grid[neighborRow * cols + neighborCol];
                            if (neighbor) {
                                const dx: number = neighbor[0] - newX;
                                const dy: number = neighbor[1] - newY;
                                if (dx * dx + dy * dy < minDist * minDist) {
                                    valid = false;
                                    break;
                                }
                            }
                        }
                    }
                    if (!valid) break;
                }
                
                if (valid) {
                    const newPoint: [number, number] = [newX, newY];
                    let sp = sprites.pop();
                    sp.pos(newX + sideOffset, newY + topOffset);
                    active.push(newPoint);
                    grid[row * cols + col] = newPoint;
                    found = true;
                    if(sprites.length == 0) {
                        return;
                    }
                    break;
                }
            }
            
            if (!found) {
                active.splice(randomIndex, 1);
            }
        }
    }

    onClickNext() {
        let DB = DataCenter.instance;
        let level = DB.level_id;

        if(this._level > 3)
        {
            Env.ShowInterstitialAd(() => {                
                DB.level_data = DB.getLevelData(level);
                LoadingRT.instance.StartMode(DB.level_mode);
            });
            return;
        }
        if(DB.free_mode)
        {
            level ++;
            Main.startLevel(level);
            return;
        }
        DB.level_data = DB.getLevelData(level);
        LoadingRT.instance.StartMode(DB.level_mode);
    }
    onClickRetry() {
        let DB = DataCenter.instance;
        if(DB.free_mode)
        {
            Main.startLevel(DB.level_id);
            return;
        }
        this.onClickNext();
    }
    onClickMain() {
        Laya.Scene.open("scenes/Main.ls");
    }
    onClickSet() {
        this._setting.visible = true;
        Env.gameStop();
    }
    onClickSettingClose() {
        this._setting.visible = false;
        Env.gameStart();
    }
    onClickSettingMain() {
        this.Lose(true);
    }

    changeToy(srcScript:Toy, toyProto: ToyProto) {
        let srcToy = srcScript.owner as Laya.Sprite;
        let srcRig = srcToy.getComponent(Laya.RigidBody);
        let toy: Laya.Image = Laya.Pool.getItemByCreateFun("toy", toyProto.prefab.create, toyProto.prefab);
        this._gameBox.addChild(toy);
        const toyScript = toy.getComponent(Toy);
        toyScript._isThunder = false;
        toyScript._srcProto = null;
        
        toyScript._oX = srcScript._oX;
        toyScript._oY = srcScript._oY;
        toy.pos(srcToy.x, srcToy.y);
        toyScript.state = srcScript.state;

        let rig = toyScript.initToy(toyProto);
        rig.type = srcRig.type;
        rig.gravityScale = srcRig.gravityScale;
        rig.allowSleep = false;
        
        toy.on(Laya.Event.MOUSE_DOWN, this, this.onClickToy);
        for(let i = 0; i < this._matchingToys.length; i++) {
            if(this._matchingToys[i] == srcToy) {
                this._matchingToys[i] = toy;
                break;
            }
        }
        if(this._maxToy == srcToy) {
            this._maxToy = toy;
        }
        if(this._minToy == srcToy) {
            this._minToy = toy;
        }
        if(srcToy == this._sideImg.parent) {
            this._main.addChild(this._sideImg);
            this._sideImg.x = -1000;
        }
        srcToy.destroy()
    }

    createToy(x: number, y: number, offsetX: number, offsetY:number, toyProto: ToyProto, spec: number): Laya.Sprite {

        let srcProto = null;
        if(spec & consts.SPECIAL_TYPE_UNKNOWN_TOY) {

            srcProto = toyProto;
            toyProto = this._toyProtos[consts.UNKOWN_TOY_PROTO];
        }
        let toy: Laya.Image = Laya.Pool.getItemByCreateFun("toy", toyProto.prefab.create, toyProto.prefab);
        toy.rotation = (Math.random() - 0.5) * 6;
        this._gameBox.addChild(toy);
        const toyScript = toy.getComponent(Toy);
        toyScript._isThunder = false;
        toyScript._srcProto = srcProto;
        //toyScript._id = this._gameBox.numChildren  + toyProto.prefab.url;
        //console.log("create toy id: " + toyScript._id);

        if(spec & consts.SPECIAL_TYPE_THUNDER) {
            toyScript._isThunder = true;
            this._has_thunder = true;
        }

        if(spec & consts.SPECIAL_TYPE_STOCK) {
            toyScript.state = TOY_STATE.STATIC;
            let rig = toyScript.initToy(toyProto);
            toyScript.enableCollider(false);
            toy.visible = false;
            rig.type = "static";
            rig.gravityScale = consts.gravity;
            rig.allowSleep = true;
            let index = y;
            let stock = this.getStocks()[index];
            stock.toys.push(toyScript);
            [x, y] = consts.getStockPos(stock.stock_index);
            
            toy.pos(x, y);
        }
        else{
            toyScript._oX = x;
            toyScript._oY = y + consts.getInitOffset();
            toy.pos(x + offsetX, y + consts.getInitOffset() + offsetY);
            toy.scaleX = 0.2
            toy.scaleY = 0.2
            Anim.Scale(toy, 0, 1.1, 300, 300);
            toyScript.state = TOY_STATE.STATIC;

            let rig = toyScript.initToy(toyProto);
            rig.type = "dynamic";
            rig.gravityScale = 0;
        }
        toy.on(Laya.Event.MOUSE_DOWN, this, this.onClickToy);
        return toy;
    }
    onClickToy(e: Laya.Event) {
        this._click.visible = false;
        this._guide_time = 2000;
        if (!this._started || this._moveTimer > 0 || this._relax_end_tick > 0) {
            return;
        }
        let toy = e.target as Laya.Sprite;
        //let matchY = GameLevel.instance.getMatchY();
        //console.log("y: " + toy.y + " matchY: " + matchY);
        let toyScript = toy.getComponent(Toy);
        if(toyScript.state !== TOY_STATE.STATIC) {
            Anim.Size(toy, 90, 90, 0, 0.85, 100, 200);
            return;
        }        
        this.toyDown(toy);
    }

    animToyDown(toy: Laya.Sprite){
        Anim.Rotate(toy, 1, 15, 180, () => {
            this.toyDown(toy);
        });
    }

    toyDown(toy: Laya.Sprite): void {
        let toyScript = toy.getComponent(Toy);
        if (toyScript.state !== TOY_STATE.STATIC && toyScript.state !== TOY_STATE.LOCKED) {
            return;
        }
        toyScript.state = TOY_STATE.DROP;

        let rig = toy.getComponent(Laya.RigidBody);
        rig.type = "dynamic";
        rig.setVelocity({ x: 0, y: consts.TOY_DOWN_VELOCITY });
        rig.applyTorque(consts.TOY_DOWN_TORQUE * (Math.random() - 0.5));
        rig.allowSleep = false;
        if(toy == this._maxToy||toy == this._minToy) {
            this._moveCountDown = consts.MOVE_COUNTDOWN;            
        }
    }
    setMaxToy(toy: Laya.Sprite) {
        this._maxToy = toy;
        if(!toy) {
            return;
        }
        toy.addChild(this._sideImg);
        this._sideImg.x = 0;
        this._sideImg.skin = (toy as Laya.Image).skin;
        Anim.Alpha1_0(this._sideImg, 1, 0.8, 500, 1000);
        // this._hover.x = toy.x;
        // this._hover.y = toy.y;
    }
    moveToys(immediate: boolean): void {
        let horizontal = this._level_type != consts.LEVEL_TYPE_BOTTOM;
        let [maxToy, minToy, maxV, minV] = this.getSideToys();
        if(this.hasStock()) {
            return;
        }
        let offset = 0;
        let len = maxV - minV;
        let allLayerGen = this._genLayerIdx >= this._layers.length;
        
        if (this._level_type == consts.LEVEL_TYPE_BOTTOM) {
            const viewHeight = consts.getViewHeight();
            if (!immediate && allLayerGen && len < viewHeight) {
                offset = consts.TOP_OFFSET - minV;
            }
            else {
                offset = this._bottomToyY - maxV;
            }
            //console.log("move", len, "max", maxV, "min",minV , "offset", offset);
            //offset += this._gameBox.y;
        }
        else if (this._level_type == consts.LEVEL_TYPE_LEFT) {
            if (!immediate && allLayerGen &&len < consts.VIEW_WIDTH) {
                offset = consts.SIDE_OFFSET - minV;
                //console.log("move left", len, "max", maxV, "min",minV , "offset", offset);
            }
            else {
                offset = ((720 - consts.SIDE_OFFSET)) - maxV;
                //console.log("move left2", len, "max", maxV, "min",minV , "offset", offset);
            }
        }
        else if (this._level_type == consts.LEVEL_TYPE_RIGHT) {
            if (!immediate && allLayerGen && len < consts.VIEW_WIDTH) {
                offset = ((720 - consts.SIDE_OFFSET)) - maxV;
            }
            else {
                offset = consts.SIDE_OFFSET - minV;
            }
            offset = -offset;
        }
        
        this.doMoveToy(offset, horizontal, immediate);
    }

    doMoveToy(offset: number, horizontal: boolean, immediate: boolean) {

        if(immediate)
        {
            this.doOffset(offset);
            this.checkLock();
            return;
        }
        if( offset < 0)
            return;
        this.checkGenLayer(-offset);
        if(this._relax_toy == null) {
            this.startMove();// wait relax end
        }
        this._expect_moving += offset;
        this._moveTimer = consts.CLICK_PROTECT_DUR;
        if(horizontal)
            Anim.Alpha1_0(this._drop_line, 2, 1, 500, 1000);
    }
    startMove() {
        for (let i = 1; i < this._gameBox.numChildren; i++) {
            const toy = this._gameBox.getChildAt(i) as Laya.Sprite;
            if(toy.y < 0)
                continue;            
            let rig = toy.getComponent(Laya.RigidBody);
            let st = toy.getComponent(Toy).state;
            if(st == TOY_STATE.STATIC || st == TOY_STATE.LOCKED) {
                rig.type = "kinematic";
            }
        }
    }

    checkLock() {
        for (let i = 1; i < this._gameBox.numChildren; i++) {
            const toy = this._gameBox.getChildAt(i) as Laya.Sprite;
            let toyScript = toy.getComponent(Toy);
            if(toyScript.state != TOY_STATE.STATIC && toyScript.state != TOY_STATE.LOCKED) {
                continue;
            }

            let lx = toy.x;
            if (this._level_type == consts.LEVEL_TYPE_LEFT && lx < consts.UNLOCK_OFFSET) {                
                toy.getComponent(Toy).setToyLocked(true);
            }            
            else if (this._level_type == consts.LEVEL_TYPE_RIGHT && lx > (720-consts.UNLOCK_OFFSET)) {
                toy.getComponent(Toy).setToyLocked(true);
            }
            else{
                toy.getComponent(Toy).setToyLocked(false);
            }

        }
    }
    doThunderEffect(): void {
        for (let i = 1; i < this._gameBox.numChildren; i++) {
            const toy = this._gameBox.getChildAt(i) as Laya.Sprite;
            let toyScript = toy.getComponent(Toy);
            if(toyScript._isThunder) {
                this.animToyDown(toy);
            }
        }
    }

    hasStock():boolean {
        return this._layers[0]._has_stock;
    }
    getStocks() :Stock[] {
        if(this._layers.length == 0) {
            return null;
        }

        return this._layers[0]._stocks;
    }


    addStock(toy_num:number, index:number):Stock {

        let stockSprite = new Laya.Sprite();
        this._stock.addChild(stockSprite);
        let stock = stockSprite.addComponent(Stock);
        stock.expect_num = toy_num;
        stock.stock_index = index;
        let pos = consts.getStockPos(index);
        stockSprite.x = pos[0];
        stockSprite.y = pos[1];
        stockSprite.pivotX = 0.5;
        stockSprite.pivotY = 0.5;
        stockSprite.rotation = 0;
        stockSprite.texture = null;

        let collide = stockSprite.addComponent(Laya.CircleCollider);
        collide.radius = consts.STOCK_RADIUS;
        collide.x = 0;
        collide.y = 0;
        collide.enabled = true;
        collide.isSensor = true;

        let rig = stockSprite.addComponent(Laya.RigidBody);
        rig.type = "static";

        let texture = this.stockTag;
        let sprite = new Laya.Text();
        sprite.x = pos[0];
        sprite.y = pos[1] + consts.STOCK_TAG_OFFSET;
        sprite.width = 39;
        sprite.height = 39;
        sprite.pivotX = 0.5;
        sprite.pivotY = 0.5;

        sprite.texture = texture;
        sprite.fontSize = 30;
        sprite.align = "center";
        sprite.valign = "middle";
        sprite.color = "#ffffff";
        sprite.text = "1";
        stock.tag = sprite;
        this._stock.addChild(sprite);

        return stock
    }
    popStock(stock_info: Stock) {
        let index = stock_info.stock_index;

        let toyScript = stock_info.popToy();

        let stock_left = stock_info.toys.length;
        if(stock_left == 0) {
            this.removeStock(stock_info);
        }
        else
            stock_info.tag.text = stock_left.toString();
        this.toyOutFromStock(toyScript.owner as Laya.Sprite);
    }
    toyOutFromStock(toy: Laya.Sprite) {        
        // toy.x = consts.getStockPos(index)[0];
        // toy.y = consts.getStockPos(index)[1];
        let toyScript = toy.getComponent(Toy);
        toyScript.enableCollider(true);
        toy.visible = true;
    }
    toyIntoStock(toy: Laya.Sprite) {
        let toyScript = toy.getComponent(Toy);
        toyScript.enableCollider(false);
        toy.visible = false;
    }


    removeStock(stock: Stock) {
        let stocks = this.getStocks();
        let index = stocks.indexOf(stock);

        //this._stock.removeChild(stock.tag)
        stock.tag.destroy();
        let stockSprite = stock.owner as Laya.Sprite;
        //this._stock.removeChild(stockSprite);
        stockSprite.destroy();
        stocks.splice(index, 1);
    }

    addBlock(x:number, y:number) {
        let block = this.block.create() as Laya.Sprite;
        block.x = x;
        block.y = consts.getInitOffset() + y - 150;
        this._dynamicBox.addChild(block);
    }

    startGame(): void {
        this.doThunderEffect();
        this._started = true;  
        Env.gameStart();
        this._start_tip.visible = false;
        this._lightning.visible = false;
    }

    stopGame(): void {
        this._started = false;
        Env.gameStop();
        this.endGame();
    }

    getSideToys(): [Laya.Sprite | null, Laya.Sprite | null, number, number] {

        if (!this._gameBox || this._gameBox.numChildren <= 1) {
            return [null, null, 0, 0];
        }
        let horizontal = this._level_type != consts.LEVEL_TYPE_BOTTOM;
        let maxToy: Laya.Sprite = null;
        let minToy: Laya.Sprite = null;
        let maxV: number = 0;
        let minV: number = 0;

        for (let i = 1; i < this._gameBox.numChildren; i++) {
            const currentToy = this._gameBox.getChildAt(i) as Laya.Sprite;
            let st = currentToy.getComponent(Toy).state;
            if(currentToy.visible == false ||  (st != TOY_STATE.STATIC && st != TOY_STATE.LOCKED)) {
                continue;
            }
            if(maxToy == null) {
                maxToy = currentToy;
                minToy = currentToy;
                maxV = currentToy.y;
                minV = currentToy.y;
                if (horizontal) {
                    maxV = maxToy.x;
                    minV = minToy.x;
                }
            }

            if (horizontal) {
                if (currentToy.x > maxV) {
                    maxV = currentToy.x;
                    maxToy = currentToy;
                }
                if (currentToy.x < minV) {
                    minV = currentToy.x;
                    minToy = currentToy;
                }
            } else {
                if (currentToy.y > maxV) {
                    maxV = currentToy.y;
                    maxToy = currentToy;
                }
                if (currentToy.y < minV) {
                    minV = currentToy.y;
                    minToy = currentToy;
                }
            }
        }

        if(this._level_type != consts.LEVEL_TYPE_RIGHT) {
            this.setMaxToy(maxToy);
            this._minToy = minToy;
        }
        else {
            this.setMaxToy(minToy);
            this._minToy = maxToy;
        }
        return [maxToy, minToy, maxV , minV];
    }
    getMatchY(): number {
        return Laya.stage.height - consts.MATCH_HEIGHT;
    }

    async matchAll() {
        while(this._leftCount > 0) {
            await new Promise(resolve => setTimeout(resolve, 200));
            this.doMatch();
        }
    }

    matched(toy1: Laya.Sprite, toy2: Laya.Sprite) {
        if(toy1 == toy2)
            toy1 = toy2;
        this.matchToy(toy1);
        this.matchToy(toy2);
        let cur_time = Laya.timer.currTimer;
        let delta_time = cur_time - this._last_match_time;
        if(delta_time < 5000) {
            this._combo++;
            if(this._combo >= 1) {
                this._comboText.value = this._combo.toString();
                this._comboText.alpha = 1;
                Anim.Alpha1_0(this._comboText, 0, 1, 1000, 500);
                this._comboText.visible = true;
            }
        }
        else {
            this._combo = 1;
            this._comboText.value = "";
            this._comboText.visible = false;
        }
        this._last_match_time = cur_time;

        let x = (toy1.x + toy2.x) / 2;
        let y = (toy1.y + toy2.y) / 2;

        let cur_score = 100 * this._combo;
        if(this._level == 1 && this._score == 0 && DataCenter.instance.level_mode == consts.MODE_COMMON) {
            this._start_tip.visible = true;
            this._start_tip.texture = this.bg;     
            this._start_tip.alpha = 1;
            this._started = false
            this._start_tip.text = LanguageService.instance.translate("guide_match");
            Laya.Tween.to(this._start_tip, { alpha: 0 }, 500, null, Laya.Handler.create(this, () => {
                this._start_tip.visible = false;
                this._started = true
            }), 4000);
        }
        this._score += cur_score;        
        Anim.ShowScore(this._dynamicBox as Laya.Sprite, this._t_scoreText, cur_score, x, y);
        
        this._leftCount -= 2;
        this._leftText.text = "" + this._leftCount;

        if(DataCenter.instance.level_mode == consts.MODE_COLLECT && toy1.getComponent(Toy)._toyProto.hasEdge) {
            this._collect_count -= 2;
            this._goal.text = "x " + this._collect_count;
            if(this._collect_count <= 0) {
                this.matchAll();
            }
        }

        if(this._leftCount <= 0) {
            Laya.timer.once(1500, this, this.Win);
        }

        if(this._level_type != consts.LEVEL_TYPE_BOTTOM) {
            let step = consts.MATCHING_MOVE_STEP;
            if(this._maxToy == null || this._minToy == null) {
                return;
            }
            let len =  Math.abs(this._maxToy.x - this._minToy.x);

            if(len > consts.VIEW_WIDTH) {
                this.doMoveToy(step, true, false);                
            }
            for (let i = 1; i < this._gameBox.numChildren; i++) {
                const toy = this._gameBox.getChildAt(i) as Laya.Sprite;
                let lx = toy.x;//+ offset
                
                if(this._level_type == consts.LEVEL_TYPE_LEFT && lx > (720 - consts.SIDE_DROP_OFFSET)) {

                    this.animToyDown(toy);
                }
                
                if(this._level_type == consts.LEVEL_TYPE_RIGHT && lx < consts.SIDE_DROP_OFFSET) {
                    this.animToyDown(toy);
                }
            }
        }
    }    

    matchToy(toy: Laya.Sprite) {
        toy.parent.addChild(toy);
        let rig = toy.getComponent(Laya.RigidBody);
        rig.setVelocity({ x: 0, y: -400 });
        if(toy == this._sideImg.parent) {
            this._dynamicBox.addChild(this._sideImg);
            this._sideImg.x = -1000;
        }
        let toyScript = toy.getComponent(Toy);
        toyScript.enableCollider(false);
        //console.log("match toy id: " + toyScript._id);

        toyScript.state = TOY_STATE.MATCHED;
        consts.playSound("resources/cdn/match.mp3");
        const index = this._matchingToys.indexOf(toy);
        if (index !== -1) {
            this._matchingToys.splice(index, 1);
        }

    }

    doWin()
    {
        consts.playSound("resources/cdn/win.mp3");
        this._win.visible = true; 
        this._win_score.text = this._score.toString();
        this._win_label.text = LanguageService.instance.translate("score");
        let DB = DataCenter.instance;
        DB.play_times = 0;
    }

    Win() {
        PhysicsGameMainRT.instance.stopGame();
        if(this._level >= 3)
            Env.happyTime();
        
        if(DataCenter.instance.free_mode) {
            this.doWin();
            return;
        }
        LoadingRT.instance.levelEnd(true, () => {
            this.doWin();
        });

    }
    stopAll()
    {
        this._started = false;
        Env.gameStop();
        let leftCount = this._toyCapacity - 2;        
        while(this._matchingToys.length > leftCount){
            let toy = this._matchingToys.pop();
            let toy_i = toy.getComponent(Toy);
            toy_i.state = TOY_STATE.DROP;
        }
        let count = this._gameBox.numChildren;
        for(let i = 1; i < count; i++) {
            let toy = this._gameBox.getChildAt(i) as Laya.Sprite;
            let toyScript = toy.getComponent(Toy);
            let st = toyScript.state;
            if(st == TOY_STATE.DROP) {
                let rig = toy.getComponent(Laya.RigidBody);                
                rig.gravityScale = 0;
                rig.setVelocity({ x: 0, y: 0 });
                rig.angularVelocity = 0;
                rig.type = "static";
            }
        }
    }
    Losing() {
        this.stopAll();
        this._revive_count++;
        if(this._revive_count > consts.MAX_REVIVE_COUNT) {
            this.Lose(false);
            return;
        }
        this.showTool(2, LanguageService.instance.translate("revive"), LanguageService.instance.translate("revivetip"), () => {
            this.doRevive();
            this._started = true;
            Env.gameStart();
        }, () => {
            this.Lose(false);
        });
    }

    DoLose() {
        consts.playSound("resources/cdn/lose.mp3");
        this._lose.visible = true;
        this._lose_content.scaleX = 0;
        this._lose_content.scaleY = 0;
        this._lose_content.visible = true;
        this._img_person.scaleX = 0;
        this._img_person.scaleY = 0;
        this._img_person.visible = false;
        this._btn_back.scaleX = 0;
        this._btn_back.scaleY = 0;
        this._btn_back.visible = false;
        this._btn_retry.scaleX = 0;
        this._btn_retry.scaleY = 0;
        this._btn_retry.visible = false;
        this._retry_tip.scaleX = 0;
        this._retry_tip.scaleY = 0;
        let DB = DataCenter.instance;
        DB.play_times ++;
        this._retry_tip.text = LanguageService.instance.translate("playtimes").replace("XXX", DataCenter.instance.play_times.toString());
        this._retry_tip.visible = false;
        Anim.Scale(this._lose_content, 0, 1.1, 200, 200, () => {
            this._img_person.visible = true;
            Anim.Scale(this._img_person, 0, 1.1, 200, 200, () => {
                this._retry_tip.visible = true;
                Anim.Scale(this._retry_tip, 0, 1.1, 200, 200, () => {
                    this._btn_retry.visible = true;
                    Anim.Scale(this._btn_retry, 0, 1.1, 200, 200, () => {
                        this._btn_back.visible = true;
                        Anim.Scale(this._btn_back, 0, 1.1, 200, 200);
                    });
                });
            }); 
        });
    }

    Lose(ret:boolean) {
        PhysicsGameMainRT.instance.stopGame();
        if(DataCenter.instance.free_mode) {
            if(ret) {
                this.onClickMain();
                return;
            }
            this.DoLose();
            return;
        }

        LoadingRT.instance.levelEnd(false, () => {
            if(ret) {
                this.onClickMain();
                return;
            }
            this.DoLose();
        });
    }
    onClickMusic() {        
        if(this._btn_music.selected) {
            consts.setMusicVolume(0);
        } else {
            consts.setMusicVolume(1);
        }
    }
    onClickSound() {
        if(this._btn_sound.selected) {
            consts.setSoundVolume(0);
        } else {
            consts.setSoundVolume(1);
        }
    }
    onClickViber() {
    }

}